import React from 'react'
import styles from './PriceMarkerTooltip.module.css'

type PriceMarkerTooltipProps = {
  children: React.ReactNode
  position: number
}

type PriceMarkerTooltipAlignment = 'left' | 'center' | 'right'

type PriceMarkerTooltipStyle = React.CSSProperties & {
  '--price-marker-tooltip-position': string
}

const getTooltipAlignment = (position: number): PriceMarkerTooltipAlignment => {
  if (position < 5) {
    return 'left'
  }
  if (position > 95) {
    return 'right'
  }
  return 'center'
}

export function PriceMarkerTooltip({ children, position }: PriceMarkerTooltipProps) {
  const alignment = getTooltipAlignment(position)
  const tooltipStyle: PriceMarkerTooltipStyle = {
    '--price-marker-tooltip-position': `${position}%`,
  }

  return (
    <div
      className={`${styles.tooltip} ${styles[alignment]}`}
      style={tooltipStyle}
      data-testid='rent-price-check-price-tooltip'
    >
      <div className={`${styles.tile} font-body-small-bold`}>{children}</div>
      <div className={styles.arrow} aria-hidden='true' />
    </div>
  )
}

export const PriceMarkerTooltipTestExports = {
  getTooltipAlignment,
}
